import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import React, { createContext, useContext, useState } from "react";
import EditionSidebar from "../components/edition/sidebar";
import ArticleView from "../components/article/view";
import Layout from "../components/layout";
import SEO from "../components/seo";
import AuthContext from "../services/firebase/auth-context/provider";
import ScrollDetector from "../components/common/scroll-detector";
import { saveReadArticle } from "../services/firebase/read-articles";
import { StatusType } from "../services/firebase/auth-context/reducer";
import ContentSidebar from "../components/article/content-sidebar";
import Error from "../components/common/error";
import { getAudioDownloadUrl } from "../services/firebase/storage";
import { datoCmsId } from "../services/dato-cms";
import SpotlightSidebar from "../components/spotlight/sidebar";
import LoginPopup from "../components/common/login-popup";
import ArticleContent from "../components/article/content/content";
import IPBasedLoginContext from "../services/ip-based-login/provider";
import { accessByMail, hasActiveSubscription } from "../util/subscription/access";
export var LoginPopupContext = /*#__PURE__*/ createContext({
    loginPopupStatus: false,
    onLoginClick: function onLoginClick() { }
});
var Article = function Article(_ref) {
    var data = _ref.data, pageContext = _ref.pageContext, location = _ref.location;
    var article = data.allDatoCmsArticle.edges[0].node;
    var withEdition = data.allDatoCmsEdition.edges.length > 0;
    var withSpotlight = data.allDatoCmsSpotlight.edges.length > 0;
    var deactivateAudio = data.allDatoCmsArticle.edges[0].node.deactivateAudio;
    var ipBased = useContext(IPBasedLoginContext);
    var authContext = useContext(AuthContext);
    var _authContext$ = authContext[0], authenticated = _authContext$.authenticated, user = _authContext$.user, userData = _authContext$.userData, userClaims = _authContext$.userClaims;
    var _hasActiveSubscription = hasActiveSubscription(userClaims) || accessByMail(user === null || user === void 0 ? void 0 : user.email);
    var _useState = useState({
        status: deactivateAudio ? "DEACTIVATED" : "LOADING"
    }), audioStatus = _useState[0], setAudioStatus = _useState[1];
    var _useState2 = useState(false), loginPopupStatus = _useState2[0], setPopupStatus = _useState2[1];
    var onScrolledToEnd = function onScrolledToEnd() {
        saveReadArticle(article.id, authContext);
    };
    var renderEditionSidebar = function renderEditionSidebar() {
        return withEdition && /*#__PURE__*/ React.createElement(EditionSidebar, {
            edition: data.allDatoCmsEdition.edges[0].node,
            authContext: authContext
        });
    };
    var renderSpotlightSidebar = function renderSpotlightSidebar() {
        return withSpotlight && /*#__PURE__*/ React.createElement(SpotlightSidebar, {
            spotlight: data.allDatoCmsSpotlight.edges[0].node,
            authContext: authContext
        });
    };
    var renderSidebar = function renderSidebar() {
        if (withEdition) {
            return renderEditionSidebar();
        }
        else if (withSpotlight) {
            return renderSpotlightSidebar();
        }
    };
    var renderContent = function renderContent() {
        return /*#__PURE__*/ React.createElement(ArticleContent, {
            article: article,
            withSpotlight: withSpotlight
        });
    };
    var renderContentSidebar = function renderContentSidebar(options) {
        var editionSlug = withEdition ? data.allDatoCmsEdition.edges[0].node.slug : null;
        var spotlightSlug = withSpotlight ? 'spotlight/' + data.allDatoCmsSpotlight.edges[0].node.slug : null;
        return /*#__PURE__*/ React.createElement(ContentSidebar, Object.assign({
            authContext: authContext,
            ipBased: ipBased,
            article: article,
            audioStatus: audioStatus,
            withSpotlight: withSpotlight,
            typeSlug: editionSlug || spotlightSlug
        }, options));
    };
    var loadAudioUrl = /*#__PURE__*/ function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee() {
            var downloadUrl;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return getAudioDownloadUrl(datoCmsId(article.id), article.slug);
                        case 3:
                            downloadUrl = _context.sent;
                            setAudioStatus({
                                status: "AVAILABLE",
                                url: downloadUrl
                            });
                            _context.next = 11;
                            break;
                        case 7:
                            _context.prev = 7;
                            _context.t0 = _context["catch"](0);
                            console.error("Audio not available: " + _context.t0.message);
                            setAudioStatus({
                                status: "ERROR",
                                message: _context.t0.message
                            });
                        case 11:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, null, [[0, 7]]);
        }));
        return function loadAudioUrl() {
            return _ref2.apply(this, arguments);
        };
    }();
    if (authenticated && userData.status === StatusType.ERROR) {
        return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(Error, {
            errorMessage: userData.error.message
        }));
    }
    if (!deactivateAudio && !(_hasActiveSubscription || ipBased) && audioStatus.status != "SUBSCRIPTION_REQUIRED") {
        setAudioStatus({
            status: "SUBSCRIPTION_REQUIRED"
        });
    }
    else if (!deactivateAudio && audioStatus.status === "LOADING") {
        loadAudioUrl();
    }
    return /*#__PURE__*/ React.createElement(Layout, {
        location: location
    }, /*#__PURE__*/ React.createElement(SEO, {
        title: article.title,
        image: article.seo && article.seo.image ? article.seo.image.fixed.src : "",
        path: location.pathname
    }), /*#__PURE__*/ React.createElement(ScrollDetector, {
        onScrolledToEnd: onScrolledToEnd
    }, /*#__PURE__*/ React.createElement(LoginPopupContext.Provider, {
        value: {
            loginPopupStatus: loginPopupStatus,
            onLoginClick: function onLoginClick() {
                return setPopupStatus(true);
            }
        }
    }, /*#__PURE__*/ React.createElement(ArticleView, {
        title: article.title,
        articleId: article.id,
        sectionTitle: article.smallTitle,
        authors: article.authors,
        image: article.image,
        visibility: article.visibility,
        renderContent: renderContent,
        renderContentSidebar: renderContentSidebar,
        renderSidebar: renderSidebar,
        audioStatus: audioStatus,
        firstPublishedAt: article.publishDate
    }))), /*#__PURE__*/ React.createElement(LoginPopup, {
        shouldShowPopup: loginPopupStatus,
        onClose: function onClose() {
            return setPopupStatus(false);
        }
    }));
};
var query = "3104396347";
export default Article;
